import {
  SHTable,
  SHTableBody,
  SHTableCell,
  SHTableContainer,
  SHTableHead,
  SHTableRow,
} from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
export const InvestmentTableItemSkeleton = () => {
  const { palette } = useTheme();

  return (
    <SHTableContainer sx={{ paddingBottom: 2 }}>
      <SHTable>
        <SHTableHead>
          <SHTableRow>
            {Array.from(Array(4).keys()).map((_, index) => {
              return (
                <SHTableCell key={index}>
                  <SHSkeleton
                    delay={false}
                    variant="text"
                    width={"50px"}
                    height={20}
                  />
                </SHTableCell>
              );
            })}
          </SHTableRow>
        </SHTableHead>

        <SHTableBody>
          {Array.from(Array(5).keys()).map((_, i) => {
            return (
              <SHTableRow
                key={i}
                sx={{
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderTopWidth: i !== 0 ? 0 : 1,
                  backgroundColor:
                    i % 2 === 0
                      ? `${palette.secondary[50]} !important`
                      : "transparent !important",
                  td: { overflow: "hidden" },
                }}
              >
                {Array.from(Array(4).keys()).map((_, index) => {
                  return (
                    <SHTableCell key={index}>
                      <SHSkeleton
                        delay={false}
                        variant="text"
                        width={"80px"}
                        height={40}
                      />
                    </SHTableCell>
                  );
                })}
              </SHTableRow>
            );
          })}
        </SHTableBody>
      </SHTable>
    </SHTableContainer>
  );
};
